export default __webpack_public_path__ + "static/media/sc.da4ec92c.svg";